import React, { useState } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import dayjs from "dayjs";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { MdCollectionsBookmark } from "react-icons/md";


function SubAdminSalesView() {
    const [salesData] = useState([
        {
            customer_name: "Ahmed Al-Farsi",
            seller_id: "UAE001",
            time: "09:30",
            date: "2024-03-01",
            place: "Dubai",
            country: "UAE",
            quantity: 5,
            status: "Completed",
            total_amount: "$500",
        },
        {
            customer_name: "Fatima Hassan",
            seller_id: "UAE002",
            time: "11:15",
            date: "2024-03-02",
            place: "Abu Dhabi",
            country: "UAE",
            quantity: 2,
            status: "Pending",
            total_amount: "$200",
        },
        {
            customer_name: "Omar Khalid",
            seller_id: "SA001",
            time: "14:45",
            date: "2024-03-03",
            place: "Riyadh",
            country: "Saudi Arabia",
            quantity: 3,
            status: "Rejected",
            total_amount: "$300",
        },
        {
            customer_name: "Aisha Al-Saud",
            seller_id: "SA002",
            time: "16:30",
            date: "2024-03-04",
            place: "Jeddah",
            country: "Saudi Arabia",
            quantity: 8,
            status: "Completed",
            total_amount: "$800",
        },
        {
            customer_name: "Zayed Mansoor",
            seller_id: "UAE003",
            time: "12:00",
            date: "2024-03-05",
            place: "Sharjah",
            country: "UAE",
            quantity: 4,
            status: "Pending",
            total_amount: "$400",
        },
        {
            customer_name: "Hassan Al-Rashid",
            seller_id: "SA003",
            time: "09:50",
            date: "2024-03-06",
            place: "Dammam",
            country: "Saudi Arabia",
            quantity: 6,
            status: "Completed",
            total_amount: "$600",
        },
        {
            customer_name: "Rajesh Kumar",
            seller_id: "IND001",
            time: "15:20",
            date: "2024-03-07",
            place: "Mumbai",
            country: "India",
            quantity: 10,
            status: "Completed",
            total_amount: "$1000",
        },
        {
            customer_name: "Priya Sharma",
            seller_id: "IND002",
            time: "10:40",
            date: "2024-03-08",
            place: "New Delhi",
            country: "India",
            quantity: 3,
            status: "Rejected",
            total_amount: "$300",
        },
        {
            customer_name: "Amit Patel",
            seller_id: "IND003",
            time: "14:10",
            date: "2024-03-09",
            place: "Chennai",
            country: "India",
            quantity: 7,
            status: "Pending",
            total_amount: "$700",
        },
        {
            customer_name: "Sara Noor",
            seller_id: "IND004",
            time: "13:45",
            date: "2024-03-10",
            place: "Hyderabad",
            country: "India",
            quantity: 5,
            status: "Completed",
            total_amount: "$500",
        },
        {
            customer_name: "Ali Al-Nuaimi",
            seller_id: "UAE004",
            time: "11:25",
            date: "2024-03-11",
            place: "Fujairah",
            country: "UAE",
            quantity: 2,
            status: "Pending",
            total_amount: "$200",
        },
        {
            customer_name: "Mohammed Bin Saud",
            seller_id: "SA004",
            time: "16:50",
            date: "2024-03-12",
            place: "Mecca",
            country: "Saudi Arabia",
            quantity: 9,
            status: "Completed",
            total_amount: "$900",
        },
        {
            customer_name: "Sneha Reddy",
            seller_id: "IND005",
            time: "08:30",
            date: "2024-03-13",
            place: "Bangalore",
            country: "India",
            quantity: 6,
            status: "Rejected",
            total_amount: "$600",
        }
    ]);


    const generatePDF = () => {
        const doc = new jsPDF();

        doc.setFontSize(20);
        doc.text("Sales Report", 14, 20);

        doc.setFontSize(12);
        doc.text(`Date: ${dayjs().format("DD-MM-YYYY")}`, 14, 30);

        const headers = [["Customer Name", "Seller ID", "Time", "Date", "Place", "Quantity", "Total Amount", "Status"]];

        const data = salesData.map(sale => [
            sale.customer_name,
            sale.seller_id,
            sale.time,
            dayjs(sale.date).format("DD-MM-YYYY"),
            sale.place,
            sale.quantity,
            sale.total_amount,
            sale.status
        ]);

        doc.autoTable({
            head: headers,
            body: data,
            startY: 40,
            theme: "striped",
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [22, 160, 133] }
        });

        doc.save("Sales_Report.pdf");
    };

    return (
        <div className="my-5">
            <h1 className="text-2xl font-bold mb-4 text-center">Sales View</h1>
            <div className="overflow-x-auto">
                <div className="w-full space-y-4">
                    <div className="grid grid-cols-[2fr,1.5fr,1.5fr,1.5fr,2fr,1.5fr,1.5fr,1.5fr] font-medium text-brand-button-green-bg">
                        <div className="text-center">Customer Name</div>
                        <div className="text-center">Seller ID</div>
                        <div className="text-center">Time</div>
                        <div className="text-center">Date</div>
                        <div className="text-center">Place</div>
                        <div className="text-center">Quantity</div>
                        <div className="text-center">Total Amount</div>
                        <div className="text-center">Status</div>
                    </div>
                </div>
                {salesData.map((sale, index) => (
                    <div
                        key={index}
                        className="grid text-[#2F2E41] min-w-[1000px] grid-cols-[2fr,1.5fr,1.5fr,1.5fr,2fr,1.5fr,1.5fr,1.5fr] items-center gap-4 py-2"
                    >
                        <div className="border p-2 rounded-xl text-center">{sale.customer_name}</div>
                        <div className="border p-2 rounded-xl text-center">{sale.seller_id}</div>
                        <div className="border p-2 rounded-xl text-center">{sale.time}</div>
                        <div className="border p-2 rounded-xl text-center flex items-center justify-center gap-2">
                            {new Date(sale.date).toLocaleDateString("en-GB")} <FaRegCalendarAlt />
                        </div>
                        <div className="border p-2 rounded-xl text-center">{sale.place}</div>
                        <div className="border p-2 rounded-xl text-center">{sale.quantity}</div>
                        <div className="border p-2 rounded-xl text-center">{sale.total_amount}</div>
                        <div className="border p-2 rounded-xl text-center">{sale.status}</div>
                    </div>
                ))}
            </div>
            <div className="flex flex-row justify-end my-5">
                <button
                    onClick={generatePDF}
                    className="flex justify-center items-center gap-2 text-gray-500 border-2 border-gray-500 rounded-2xl px-10 py-2"
                >
                    <MdCollectionsBookmark  fontSize={25}/>
                    Print Receipt
                </button>
            </div>
        </div>
    );
}

export default SubAdminSalesView;